import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export const ReportsHome = () => {
  return (
    <Box>
      <Typography>Reports Home</Typography>
    </Box>
  );
};
